
import { Loading, Notification } from 'element-ui'
import axios from 'axios'
import qs from 'qs'

// axios.interceptors.request.use(config => {
//   if (config.method == 'post') {
//     config.data = {
//       data: config.data,
//       _t: Date.parse(new Date().getTime()) / 1000
//     }
//   } else if (config.method == 'get') {
//     config.params = {
//       _t: Date.parse(new Date().getTime()) / 1000,
//       ...config.params
//     }
//   }
//   return config
// })
axios.interceptors.response.use(function(response) {
  if(response.data.status === false) {
    Notification.error({title: '错误', message: response.data.remark, duration: 2000})
  }
  // 对响应数据做点什么
  return response;
}, function(err) {
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        err.message = '请求错误(400)';
        break;
      case 401:
        err.message = '未授权，请重新登录(401)';
        break;
      case 403:
        err.message = '拒绝访问(403)';
        break;
      case 404:
        err.message = '请求出错(404)';
        break;
      case 408:
        err.message = '请求超时(408)';
        break;
      case 500:
        err.message = '服务器错误(500)';
        break;
      case 501:
        err.message = '服务未实现(501)';
        break;
      case 502:
        err.message = '网络错误(502)';
        break;
      case 503:
        err.message = '服务不可用(503)';
        break;
      case 504:
        err.message = '网络超时(504)';
        break;
      case 505:
        err.message = 'HTTP版本不受支持(505)';
        break;
      default:
        err.message = `连接出错(${err.response.status})!`;
    }
  } else {
    err.message = '连接服务器失败!'
  }
  Notification.error({title: '错误', message: err.message, duration: 0})
  return Promise.reject(err);
});



// 获取广告运营接口
export function GetUserAdOperatorUser(param) {
  return axios.post(`/IAD_Customer/GetUserAdOperatorUser?_t=${new Date().getTime()}`, param).then(res => {
    return Promise.resolve(res.data)
  })
}


// 获取媒介接口
export function getSourceman(param) {
  return axios.post(`/IAD_Customer/getSourceman?_t=${new Date().getTime()}`, param).then(res => {
    return Promise.resolve(res.data)
  })
}

// 获取媒体运营接口
  export function GetSourceOperatorUserList(param) {
  return axios.post(`/IAD_Customer/GetSourceOperatorUserList?_t=${new Date().getTime()}`, param).then(res => {
    return Promise.resolve(res.data)
  })
}

//获取媒体商信息接口
export function GetMediaUserInfo(param) {
  let loadingInstance = Loading.service()
  return axios.post(`/IAD_Customer/GetMediaUserInfo?_t=${new Date().getTime()}`, param).then(res => {
    loadingInstance.close()
    return Promise.resolve(res.data)
  })
}

// 添加、修改媒体商信息接口
export function EditUserDetail(param) {
  let loadingInstance = Loading.service()
  return axios.post(`/IAD_Customer/EditUserDetail?_t=${new Date().getTime()}`, param).then(res => {
    loadingInstance.close()
    return Promise.resolve(res.data)
  })
}

//上传证件照接口
export function UploadImg(param) {
  let loadingInstance = Loading.service()
  return axios.post(`/IAD_PutOn/UploadImg?_t=${new Date().getTime()}`, param).then(res => {
    loadingInstance.close()
    return Promise.resolve(res.data)
  })
}

// 获取分广告数据列表接口
export function GetPlanAdstatis(param) {
  let loadingInstance = Loading.service()
  return axios.post(`/IAD_ADStatis/GetPlanAdstatis?_t=${new Date().getTime()}`, param).then(res => {
    loadingInstance.close()
    return Promise.resolve(res.data)
  })
}


// 导出分广告数据接口
export function ExportPlanAdstatis(param) {
  return axios.post(`/IAD_Customer/ExportPlanAdstatis?_t=${new Date().getTime()}`, param).then(res => {
    return Promise.resolve(res.data)
  })
}


// 获取合同公司接口
export function GetContractCompanyEnum(param) {
  return axios.post(`/IAD_Customer/GetContractCompanyEnum?_t=${new Date().getTime()}`, param).then(res => {
    return Promise.resolve(res.data)
  })
}

//获取用户是否代理运营接口
export function GetIsAgent(param) {
  return axios.post(`/IAD_ADStatis/GetIsAgent?_t=${new Date().getTime()}`, param).then(res => {
    return Promise.resolve(res.data)
  })
}


//获取广告计划ID接口
export function GetAdvertiseInfo(param) {
  return axios.post(`/IAD_ADStatis/GetAdTaskNameAndPutonIdByLike?_t=${new Date().getTime()}`, param).then(res => {
    return Promise.resolve(res.data)
  })
}



// WEBPACK FOOTER //
// ./src/api/customerManagement.js